module.exports = __webpack_public_path__ + "static/img/DSC_2684.ab62fa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2684.jpg
// module id = 274
// module chunks = 0